import React, { useState, useEffect, useContext } from "react";
import styles from "./Footer.module.sass";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { GlobalContext } from "src/GlobalContext";
import LazyLoad from "react-lazyload";
import { Helmet } from "react-helmet";

export default function Footer({ logo }) {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const [otherEvents, setOtherEvents] = useState();
  const [socialMediaLinks, setSocialMediaLinks] = useState();
  // console.log("social links--", socialMediaLinks);
  const [navLinks, setnavLinks] = useState([]);
  const { eventYear, eventName } = useContext(GlobalContext);
  // const [logo, setlogo] = useState();
  const [width, setwidth] = useState(window.innerWidth);
  useEffect(() => {
    if (window.hbspt) {
      window.hbspt.forms.create({
        portalId: "YOUR-PORTAL-ID",
        formId: "YOUR-FORM-ID",
        target: "YOUR-FORM-CONTAINER-ID",
      });
    }

    function handleResize() {
      setwidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    fetchData();
    getSocialMediaLinks();
    fetchNavData();
    // fetchData();
  }, [window.hbspt]);

  // async function fetchData() {
  //   try {
  //     const result = await axios
  //       .get(`${process.env.REACT_APP_API_SERVER_URL}/logo`)
  //       .then((response) => {
  //         setlogo(response.data[0].logo);
  //       });
  //   } catch (err) {
  //     console.log("Event api error", err);
  //   }
  // }
  async function fetchData() {
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_API_SERVER_URL}/upcoming-events`
      );
      if (result.status == 200) {
        setOtherEvents(result.data);
      }
    } catch (err) {
      console.log("other events api error", err);
    }
  }
  async function fetchNavData() {
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_API_SERVER_URL}/footer-navigation`
      );
      if (result.status == 200) {
        // console.log("navLink--", result.data[0].value);
        setnavLinks(result.data);
        // result?.data.map((v, i) => {
        //   if (v.value == 1)
        //   setnavLinks(v);
        // });
      }
    } catch (err) {
      console.log("other events api error", err);
    }
  }
  const getSocialMediaLinks = async () => {
    await axios
      .get(`${process.env.REACT_APP_API_SERVER_URL}/social-media`)
      .then((response) => {
        setSocialMediaLinks(response.data);
      });
  };
  // console.log(socialMediaLinks);
  return (
    <React.Fragment>
      <footer className={styles.footer}>
        <div className={styles.Footercontainer}>
          <div className={styles.footerUpperContainer}>
            <div className={styles.footerLogo}>
              <LazyLoad>
                <img
                  src={`${process.env.REACT_APP_API_SERVER_URL}/${logo}`}
                  alt="Site Logo"
                  onClick={() => {
                    navigate("/");
                    window.scrollTo(0, 0);
                  }}
                  height="64"
                />
              </LazyLoad>
            </div>
            <div className={styles.footerNav}>
              <div className={styles.footerNavItem}>
                <Link to={navLinks[0]?.link ? navLinks[0].link : "#"}>
                  {navLinks[0] && navLinks[0]?.value == 1
                    ? navLinks[0]?.label
                    : null}
                </Link>
                <Link to={navLinks[1]?.link ? navLinks[1].link : "#"}>
                  {navLinks[1] && navLinks[1]?.value == 1
                    ? navLinks[1]?.label
                    : null}
                </Link>
              </div>
              <div className={styles.footerNavItem}>
                <Link to={navLinks[2]?.link ? navLinks[2].link : "#"}>
                  {navLinks[2] && navLinks[2]?.value == 1
                    ? navLinks[2]?.label
                    : null}
                </Link>
                <Link to={navLinks[3]?.link ? navLinks[3].link : "#"}>
                  {navLinks[3] && navLinks[3]?.value == 1
                    ? navLinks[3]?.label
                    : null}
                </Link>
              </div>
              {width > 768 ? (
                <div className={styles.footerNavItem}>
                  <Link to={navLinks[4]?.link ? navLinks[4].link : "#"}>
                    {navLinks[4] && navLinks[4]?.value == 1
                      ? navLinks[4]?.label
                      : null}
                  </Link>
                  <Link to={navLinks[5]?.link ? navLinks[5].link : "#"}>
                    {navLinks[5] && navLinks[5]?.value == 1
                      ? navLinks[5]?.label
                      : null}
                  </Link>
                </div>
              ) : (
                <>
                  <div className={styles.footerNavItem}>
                    <Link to={navLinks[4]?.link ? navLinks[4].link : "#"}>
                      {navLinks[4] && navLinks[4]?.value == 1
                        ? navLinks[4]?.label
                        : null}
                    </Link>
                    {/* <Link to="/benefits">
                  {navLinks[5] && navLinks[5]?.value == 1
                    ? navLinks[5]?.label
                    : null}
                </Link> */}
                  </div>
                  <div className={styles.footerNavItem}>
                    {/* <Link to="/agenda-page">
                  {navLinks[4] && navLinks[4]?.value == 1
                    ? navLinks[4]?.label
                    : null}
                </Link> */}
                    <Link to={navLinks[5]?.link ? navLinks[5].link : "#"}>
                      {navLinks[5] && navLinks[5]?.value == 1
                        ? navLinks[5]?.label
                        : null}
                    </Link>
                  </div>
                </>
              )}
              <div className={styles.footerNavItem}>
                <Link to={navLinks[6]?.link ? navLinks[6].link : "#"}>
                  {navLinks[6] && navLinks[6]?.value == 1
                    ? navLinks[6]?.label
                    : null}
                </Link>
                <Link to={navLinks[7]?.link ? navLinks[7].link : "#"}>
                  {navLinks[7] && navLinks[7]?.value == 1
                    ? navLinks[7]?.label
                    : null}
                </Link>
              </div>
              <div className={styles.footerNavItem}>
                <Link to={navLinks[8]?.link ? navLinks[8].link : "#"}>
                  {navLinks[8] && navLinks[8]?.value == 1
                    ? navLinks[8]?.label
                    : null}
                </Link>
                <Link to={navLinks[9]?.link ? navLinks[9].link : "#"}>
                  {navLinks[9] && navLinks[9]?.value == 1
                    ? navLinks[9]?.label
                    : null}
                </Link>
              </div>
            </div>
          </div>
          <div className={styles.hr}></div>
          <div className={styles.footerLowerContainer}>
            {socialMediaLinks && (
              <div className={styles.footerIconsContainer}>
                {socialMediaLinks &&
                  socialMediaLinks.map((element, index) => {
                    if (element.value) {
                      if (
                        element.label === "Twitter" ||
                        element.label === "Facebook"
                      ) {
                        return null;
                      } else if (element.value === "#") {
                        return (
                          <a href={null} key={index}>
                            <img
                              src={element.imgsrc}
                              alt={element.label}
                              width="20"
                              height="20"
                            />
                          </a>
                        );
                      } else {
                        return (
                          <a
                            target="_blank"
                            href={
                              element.option === "instagram_url"
                                ? `mailto:${element.value}?subject=${eventName} ${eventYear}`
                                : element.value
                            }
                            key={index}
                          >
                            <img
                              src={element.imgsrc}
                              alt={element.label}
                              width="20"
                              height="20"
                            />
                          </a>
                        );
                      }
                    }
                  })}
              </div>
            )}
            <div className={styles.footerQuickLinksContainer}>
              <div
                className={`${styles.footerQuickLinks} ${styles.quickLinksFirst}`}
              >
                <h5>OTHER EVENTS</h5>
                {Array.isArray(otherEvents) &&
                  otherEvents?.map((v, i) => {
                    let evetName = v?.eventname.replace(/,/g, " ");
                    return (
                      <a
                        href={v?.eventlink}
                        target="_blank"
                        key={i}
                        style={{
                          textTransform: "uppercase",
                          pointerEvents:
                            v?.link?.length <= 0 || v?.link === "#"
                              ? "none"
                              : "auto",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: evetName,
                        }}
                      ></a>
                    );
                  })}
              </div>
              <div className={styles.footerQuickLinks}>
                <h5>QUICK LINKS</h5>
                <Link to="/booking">Register</Link>
                <Link to="/who-should-attend">Benefits</Link>
                <Link to="/faq">FAQ</Link>
              </div>
              <div className={styles.footerQuickLinks}>
                <h5>CONTACT US</h5>
                <Link
                  to={`mailto:delegates@iq-hub.com?subject=${eventName} ${eventYear}`}
                >
                  Email
                </Link>
                <Link to="/contact-us">Customer Support</Link>
                <Link to="/terms-and-conditions">Terms and Conditions</Link>
              </div>
            </div>
          </div>
          <div className={styles.hr}></div>
          <div className={styles.footerBottom}>
            <p>
              <Link to="/privacy-policy">Privacy Policy</Link>
              <span> | </span>IQ International PTe. LTD
            </p>
            <p>
              ©{currentYear} {eventName && eventName} {eventYear && eventYear}
            </p>
          </div>
        </div>
        <Helmet>
          <script
            type="text/javascript"
            id="hs-script-loader"
            async
            defer
            src="//js.hs-scripts.com/4000965.js"
          ></script>
        </Helmet>
      </footer>
    </React.Fragment>
  );
}
